<template>
<v-dialog v-model="dialog" persistent max-width="400px">
  <v-card>
    <v-toolbar dense dark color="primary elevation-1">
      <v-toolbar-title>Disponibilité: {{ driver.id }}. {{driver.lastname}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="close" dark>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
  <div class="agenda pa-5">
    <v-layout row wrap justify-center class="pb-2">
      <div class="date text-center">{{ selectedDate | date }}</div>
      <v-flex xs12>
        <v-date-picker
          no-title
          full-width
          v-model="selectedDate"
          :events="calendarEvents"
          event-color="primary"
          :min="startDate"
          :locale="$i18n.locale"
        ></v-date-picker>
      </v-flex>
      <v-flex xs12>
        <div class="available-title grey--text pt-2">
          {{ $t("agenda.select") }}
        </div>
        <v-card class="mt-2" flat>
          <v-card-title class="available-select pa-2">
            <v-select
              dense
              color="primary"
              text-color="primary"
              flat
              v-model="available"
              :items="selectedItems"
              prepend-icon="event_available"
              chips
              :label="$t('agenda.notworking')"
              multiple
              solo
              hide-details
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  color="primary"
                  text-color="white"
                  :input-value="data.selected.value"
                  small
                  @input="remove(data.item)"
                >
                  <strong>{{ data.item.text }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-select>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
  </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
import AgendaMixin from "@/mixins/driver-dispo";
export default {
  mixins: [AgendaMixin],
  props: ['dialog', 'driver'],
  data: () => ({
    startDate: moment().format("YYYY-MM-DD"),
    selectedItems: [
      { text: "7h - 9h", value: 0 },
      { text: "9h - 11h", value: 1 },
      { text: "11h - 13h", value: 2 },
      { text: "13h - 15h", value: 3 },
      { text: "15h - 17h", value: 4 },
      { text: "17h - 19h", value: 5 },
    ],
    userEvents: {},
    selectedDate: moment().format("YYYY-MM-DD"),
    available: [],
    calendarEvents: [],
  }),
  methods: {
    reset() {
      this.userEvents = {},
      this.selectedDate = moment().format("YYYY-MM-DD"),
      this.available = [],
      this.calendarEvents = []
    },
    close () {
      this.$emit('close');
    },
    setAvailable() {
      this.userEvents[this.selectedDate] =
        this.userEvents[this.selectedDate] || {};
      console.log(
        "3 ------------------- setAvailable: ",
        this.userEvents[this.selectedDate].available
      );
      if (this.userEvents[this.selectedDate].available) {
        this.available = this.userEvents[this.selectedDate].available;
      } else {
        this.available = [];
      }
    },
    remove(item) {
      this.available.splice(this.available.indexOf(item), 1);
      this.available = [...this.available];
      this.update(this.available);
    },
    update(data) {
      var app = this;
      console.log("1 update selected", data);
      this.save({
        driverId: app.driver.id,
        date: app.selectedDate,
        available: data.toString(),
      }).then((result) => {
        app.getEvents(app.driver.id).then((result) => {
          app.calendarEvents = result;
          console.log("2 setAvailable: ", result);
          app.setAvailable();
        });
      });
    },
    init (value) {
      if (value) {
        console.log('init dispo:', value);
        this.reset();
        this.getEvents(this.driver.id).then((result) => {
          this.calendarEvents = result;
          this.setAvailable();
        });
        console.log("selectedDate", this.selectedDate);
      }
    }
  },
  computed: {},
  watch: {
    selectedDate() {
      this.setAvailable();
    },
    available(value, oldvalue) {
      console.log("watch available: ", value, oldvalue);
      if (JSON.stringify(value) !== JSON.stringify(oldvalue)) {
        this.update(value);
      }
    },
    selectedEvent: {
      handler: function (value) {
        // this.update(value)
        // this.save(this.selectedEvent);
      },
      deep: true,
    },
    dialog (value) {
      this.init(value);
    }
  },
};
</script>
<style lang="scss">
.agenda {
  .available-title {
    word-break: normal;
    line-height: 15px;
    text-align: left;
    font-size: 14px;
    width: 100%;
  }
  .date {
    font-size: 22px;
    color: $primary;
  }

  .v-sheet.v-card {
    border: solid 1px rgb(184, 182, 182);
  }
}
</style>

